module.exports = __webpack_public_path__ + "img/slack.f40d983c.svg";